import { selectIsFetching as selectIsFetchingCustomer } from './state/detail/selector'
import { selectIsFetching as selectIsFetchingFileUpload } from './state/file-upload/selector'
import { selectIsFetching as selectIsFetchingSearch } from './state/search/selector'

export default {
    action: {},
    selector: {
        selectIsFetching: (state) => {
            return selectIsFetchingCustomer(state) || selectIsFetchingFileUpload(state) || selectIsFetchingSearch(state)
        },
    },
}



// WEBPACK FOOTER //
// ./src/modules/customer/index.js